import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'product' })
export class ProductPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case 'SNS':
        result = 'SNS';
        break;
      case 'PRODUCT':
        result = '제품';
        break;
      case 'ARCHIVE':
        result = '압축';
        break;
    }
    return result;
  }
}
